import { render, staticRenderFns } from "./AddPatientToSurgery.vue?vue&type=template&id=6c4c6e98&scoped=true"
import script from "./AddPatientToSurgery.vue?vue&type=script&lang=js"
export * from "./AddPatientToSurgery.vue?vue&type=script&lang=js"
import style0 from "./AddPatientToSurgery.vue?vue&type=style&index=0&id=6c4c6e98&prod&lang=scss&scoped=true"
import style1 from "./AddPatientToSurgery.vue?vue&type=style&index=1&id=6c4c6e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4c6e98",
  null
  
)

export default component.exports